export const AXIOS_CONFIG = {
    ENDPOINT: 'api/v1/campaigns',
    TIMEOUT: 2000,
};

export default {
    AXIOS_CONFIG,
};
